import type {PublicMethodUtils} from '@wix/document-services-types'
import type {PatternsPublicAPI} from '@wix/document-services-public-types'
import {patterns} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<PatternsPublicAPI> {
    return {
        methods: {
            components: {
                patterns: {
                    getVariantsForItem: publicMethodUtils.defineGetter(patterns.getVariantsForItem),
                    apply: publicMethodUtils.defineDataManipulationAction(patterns.apply),
                    get: publicMethodUtils.defineGetter(patterns.get),
                    createVariant: publicMethodUtils.defineDataManipulationAction(
                        patterns.createRepeaterPatternVariant,
                        {
                            getReturnValue: patterns.getRepeaterPatternVariantToAddRef
                        }
                    ),
                    getRepeaterPatternVariants: publicMethodUtils.defineGetter(patterns.getRepeaterPatternVariants),
                    remove: publicMethodUtils.defineDataManipulationAction(patterns.remove)
                }
            }
        }
    }
}
